import React from 'react';

// Components.
import { CardText } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import VerifiedContent from '../VerifiedContent';

function ExistingRoleContent({ userRoleTitle, discordInviteCode }) {
  return (
    <div>
        <CardText tag="h3" className="fw-semibold text-center text-primary-orange-emphasis mb-3">
            Already Locked In
        </CardText>

        <div className="py-3 border-top border-bottom border-primary-orange-subtle">
            <div className="text-center fs-5">
                <CardText className="mb-0 fs-4 text-secondary">
                    You&apos;re already registered as
                </CardText>
                
                <CardText className="fs-2 fw-semibold text-light sigmar-regular" style={{ letterSpacing: '0.15rem'}}>
                    {userRoleTitle}
                </CardText>

                <CardText className="mb-0 text-secondary">
                    <strong>Next: </strong>
                    Enter Discord if you still need onboarding access.
                </CardText>

                <a
                    href={`https://discord.gg/${discordInviteCode}`}
                    rel="noreferrer"
                    target="_blank"
                    className="btn btn-discord btn-lg mt-4 mb-3 fw-semibold px-4"
                >
                    <div className="d-flex justify-content-center align-items-center gap-2">
                        <FontAwesomeIcon
                            icon={faDiscord}
                            size="lg"
                            className="discord-icon"
                        />
                        <span>Enter Discord</span>
                    </div>
                </a>

                <CardText className="fs-smaller text-light mb-0">
                    Your access to private {userRoleTitle} channels is tied to this account.
                </CardText>
            </div>

            <div className="mt-3">
                <VerifiedContent isBetaRoleCardShown={false} />
            </div>
        </div>
    </div>
  );
}

export default ExistingRoleContent;
